export default __webpack_public_path__ + "static/media/auth-background.055da37b.png";